export default "__VITE_ASSET__D$8_fl$D__"